<div class="dashboard-suggestions" *ngIf="!isLoading">
    <ng-container *ngFor="let group of progressByLevel">
      <div class="dashboard-suggestions__group">
        <h3 class="dashboard-suggestions__title">{{ group.level }}</h3>
  
        <swiper
          class="dashboard-suggestions__swiper"
          [slidesPerView]="4"
          [pagination]="{ clickable: true }"
          [spaceBetween]="10"
          [breakpoints]="{
            '320': { slidesPerView: 1.2 },
            '768': { slidesPerView: 2.5 },
            '1024': { slidesPerView: 4 }
          }"
        >
          <ng-template swiperSlide *ngFor="let item of group.progressItems">
            <app-school-socio-emotional-dashboard-suggestions-card
              [suggestion]="item"
            ></app-school-socio-emotional-dashboard-suggestions-card>
          </ng-template>
        </swiper>
      </div>
    </ng-container>
  </div>
  
  <div class="dashboard-suggestions__loading" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  